module.exports = __webpack_public_path__ + "1cd5320f8937d337b61d5117cf9d7b28.woff";